import uaParser from 'ua-parser-js'

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const { ua, ...browserInfo } = uaParser()

function getBrowserInfo() {
  if (window.HPP_SETTINGS && window.HPP_SETTINGS.browser_tests_overides) {
    return window.HPP_SETTINGS.browser_tests_overides.browser_info
  }

  return browserInfo
}

export default getBrowserInfo
